module.exports = __webpack_public_path__ + "static/media/checkin-playback.65e8deb7.png";